// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React, { useState } from 'react';
import {
  IconButton,
  Box,
  Badge,
  Menu,
  MenuItem,
  Typography,
  Chip,
  Stack,
} from '@mui/material';
import { IconBellRinging, IconMail } from '@tabler/icons-react';
import { useNotifications } from '@/context/NotificationContext';
import Scrollbar from '@/components/custom-scroll/Scrollbar';
import { Link } from 'react-router';

const Notifications = () => {
  const [anchorEl2, setAnchorEl2] = useState(null);
  const { notifications, unreadCount, markAsRead, getNotificationLink } = useNotifications();

  const handleClick2 = (event: any) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const handleNotificationClick = async (notification: any) => {
    await markAsRead(notification.id);
    handleClose2();
  };

  return (
    <Box>
      <IconButton
        size="large"
        aria-label={`show ${unreadCount} new notifications`}
        color="inherit"
        aria-controls="msgs-menu"
        aria-haspopup="true"
        sx={{
          color: anchorEl2 ? 'primary.main' : 'text.secondary',
        }}
        onClick={handleClick2}
      >
        <Badge badgeContent={unreadCount} color="primary">
          <IconBellRinging size="21" stroke="1.5" />
        </Badge>
      </IconButton>
      {/* ------------------------------------------- */}
      {/* Message Dropdown */}
      {/* ------------------------------------------- */}
      <Menu
        id="msgs-menu"
        anchorEl={anchorEl2}
        keepMounted
        open={Boolean(anchorEl2)}
        onClose={handleClose2}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        sx={{
          '& .MuiMenu-paper': {
            width: '360px',
          },
        }}
      >
        <Stack direction="row" py={2} px={4} justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Notifications</Typography>
          <Chip label={`${unreadCount} new`} color="primary" size="small" />
        </Stack>
        <Scrollbar sx={{ height: '385px' }}>
          {notifications.length === 0 ? (
            <Box sx={{ py: 4, px: 4, textAlign: 'center' }}>
              <Typography variant="subtitle2" color="textSecondary">
                No notifications
              </Typography>
            </Box>
          ) : (
            notifications.map((notification) => (
              <Box key={notification.id}>
                <MenuItem 
                  sx={{ py: 2, px: 4 }}
                  component={Link}
                  to={getNotificationLink(notification)}
                  onClick={() => handleNotificationClick(notification)}
                >
                  <Stack direction="row" spacing={2}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        backgroundColor: notification.isRead ? 'grey.300' : 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <IconMail size={24} color="white" />
                    </Box>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        color="textPrimary"
                        fontWeight={notification.isRead ? 400 : 600}
                        noWrap
                        sx={{
                          width: '240px',
                        }}
                      >
                        {notification.title}
                      </Typography>
                      <Typography
                        color="textSecondary"
                        variant="subtitle2"
                        sx={{
                          width: '240px',
                        }}
                        noWrap
                      >
                        {notification.subtitle}
                      </Typography>
                    </Box>
                  </Stack>
                </MenuItem>
              </Box>
            ))
          )}
        </Scrollbar>
        {/* TODO: Uncomment when notifications page is ready */}
        {/* <Box p={3} pb={1}>
          <Button to="/apps/notifications" variant="outlined" component={Link} color="primary" fullWidth>
            See all Notifications
          </Button>
        </Box> */}
      </Menu>
    </Box>
  );
};

export default Notifications;
